<template>
    <div class="position-relative chart-panel">
        <h3>กราฟบันทึกอุณหภูมิตู้ยาและเวชภัณฑ์ {{ monthlyTitle }}</h3>
        <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>

        <div v-if="isLoading" class="loading-overlay">
            <div class="loading-box">
                <div class="spinner-border text-primary" role="status"></div>
                <strong>กำลังโหลดข้อมูล...</strong>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, watch } from 'vue';
import axiosInstance from '@/utils/axiosInstance';
import VueApexCharts from 'vue3-apexcharts';
import moment from 'moment';
import 'moment/locale/th';

export default {
    components: {
        apexchart: VueApexCharts
    },
    props: {
        filters: {
            type: Object,
            default: () => ({})
        },
        reloadKey: {
            type: Number,
            default: 0
        }
    },
    setup(props) {
        const isLoading = ref(false);
        const monthlyTitle = ref('');
        const series = ref([]);
        const chartOptions = ref({
            chart: { id: 'medicine-cabinet-temperature-chart', height: 150 },
            xaxis: {
                categories: [],
                labels: { style: { fontSize: '12px' } }
            },
            stroke: { curve: 'smooth' },
        });

        const fetchChartData = async () => {
            if (!props.filters.group_id) {
                chartOptions.value.xaxis.categories = [];
                series.value = [];
                monthlyTitle.value = '';
                return;
            }

            try {
                isLoading.value = true;
                const response = await axiosInstance.get('/mc/records-per-day', {
                    params: props.filters,
                });
                const data = response.data;

                moment.locale('th');
                monthlyTitle.value = props.filters.month
                    ? moment().locale('th').month(Number(props.filters.month) - 1).format('MMMM')
                    : '';

                chartOptions.value.xaxis.categories = data.map(item => moment(item.date).format('D MMM'));
                series.value = [{
                    name: 'จำนวนบันทึก',
                    data: data.map(item => item.count),
                }];
            } catch (error) {
                console.error('Error fetching medicine cabinet chart data:', error);
            } finally {
                isLoading.value = false;
            }
        };

        watch(() => props.reloadKey, (reloadKey) => {
            if (reloadKey > 0) {
                fetchChartData();
            }
        });

        return { series, chartOptions, monthlyTitle, isLoading };
    }
};
</script>

<style scoped>
.chart-panel {
    min-height: 420px;
}

.loading-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.78);
    backdrop-filter: blur(2px);
    z-index: 5;
}

.loading-box {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 18px;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.16);
    color: #1f2937;
}
</style>
